import { useEffect, useMemo } from 'react';
import useRefresh from '@/hooks/useRefresh';
import BreadCrumbs from '@/components/bread-crumbs';
import { useHistory } from 'react-router-dom';

const hideBreadCrumbInPathname: Record<string, boolean | ((pathname: string) => boolean)> = {
  // 工作台
  '/': true,
  // 主题活动
  '/activity-manage/list': true,

  // 日常活动
  // 会场收品
  /* 会场收品 */ '/activity-manage/myCreate/room/activityReceipt': true,
  // /* 可参与的活动 */ '/activity-manage/myCreate/room/join': true, //activityReceipt建设完毕，老的不要了，替换成新的
  // /* 我管理的活动 */ '/activity-manage/myCreate/room/manage': true, //activityReceipt建设完毕，老的不要了，替换成新的
  /* 待审核管理的 */ '/activity-manage/myCreate/room/check': true,
  /* 视觉审核管理 */ '/activity-manage/myCreate/room/managerpending': true,
  // 通天塔项目
  '/activity-manage/myCreate/avenue': true,
  // 盘货活动
  '/activity-manage/myCreate/ph/phlist/manage': true,
  '/activity-manage/myCreate/ph/phlist/enroll': true,
  // 综促活动
  /* 我创建的活动 */ '/activity-manage/myCreate/zongcuActivity/myCreate': true,
  /* 我参与的活动 */ '/activity-manage/myCreate/zongcuActivity/myJoin': true,
  /* 我管理的活动 */ '/activity-manage/myCreate/zongcuActivity/myManage': true,
  // 已报名素材
  '/all-about-me': () => true,
  // 平台营销阵地
  '/platform-marketing'() {
    return true;
  },
  //营销能力矩阵
  '/function-matrix': true,
  // 频道阵地
  '/channel-service': true,
  '/channel-service/resource-detail': () => true,
  '/channel-service/position'() {
    return true;
  },
  '/user-operate': true,
  // 平台资源
  /* 活动数据   */ '/material-manage/activity-data/data/home': true,
  /* 资源位列表 */ '/material-manage/resource-list/list': true,
  /* 资源申请管理*/ '/material-manage/resource-manage': true,
  /* 资源申请列表*/ '/material-manage/resource-apply-list': true,
  /* 资源广场   */ '/material-manage/resource-square': true,
  // 素材管理
  '/res-manage': function () {
    return true;
  },
  // 数据作战室
  '/data-panel': function () {
    return true;
  },
  '/activity-manage/merchants': function () {
    return true;
  },
  '/activity-manage/create': true,
  // 趋势运营
  /* 趋势管理 */ '/trend-operation/trend-manage/trend-idea': true,
  /* 权限管理 */ '/trend-operation/permission-manage': true,
  // 盘活工具
  '/ph': function () {
    return true;
  },
  // 系统设置
  '/system/shield-policy': true, // 屏蔽策略配置
  // 权限管理
  /* 权限管理 */
  '/system/powermanage': true,
  /* 权限管理 */
  '/system/powermanage/powerManageFresh': true,
  // 货品监控
  '/channel-micro/my-manager': true,
  '/product-manager/big-boss-panel': true,
  // 新潘多拉
  '/selection': () => true,
  // 微频道管理
  '/product-manager/': true,
  '/product-manager': true,
  '/channel-micro/my-approve': true,
  '/batch-micro': true,
  '/user-setting'() {
    return true;
  },
  // 投放内嵌
  '/material/'() {
    return true;
  },
  '/material': true,
  '/swifthorse'() {
    return true;
  },
  '/launch'() {
    return true;
  },
  '/pandora'() {
    return true;
  },
  '/interaction'() {
    return true;
  },
  '/wiki'() {
    return true;
  },
  '/kpl'() {
    return true;
  },
  '/search-operate': true,
  '/jinghailu': () => true,
  '/information-center': () => true,
  '/recommend-operate'() {
    return true;
  },
  '/cargo-gold-operate': true,
  '/category-diy': true,
  '/yxtools': true,
  '/operations-workbench': () => true,
};
// eslint-disable-next-line
function shouldHideCrumb(pathname: string) {
  if (typeof hideBreadCrumbInPathname[pathname] === 'boolean') return hideBreadCrumbInPathname[pathname];

  // 小于等于两级就不展示面包屑
  if (pathname.split('/').length <= 3) return true;

  // 动态的key
  const dynamicPath = Object.keys(hideBreadCrumbInPathname).reduce((prev, cur) => {
    if (typeof hideBreadCrumbInPathname[cur] === 'boolean') return prev;

    prev[cur] = hideBreadCrumbInPathname[cur] as (pathname: string) => boolean;

    return prev;
  }, {} as Record<string, (pathname: string) => boolean>);

  const inPath = Object.keys(dynamicPath).find((key: string) => pathname.indexOf(key) === 0);

  if (!inPath) return false;

  return dynamicPath[inPath](pathname);
}

function shouldShowCrub(pathname: string): boolean {
  return pathname.indexOf('/system') === 0;
}

export default function OutestBreadCrumb() {
  const history = useHistory();
  const refresh = useRefresh();

  useEffect(() => {
    return history.listen(refresh);
  }, [history, refresh]);

  const pathname = window.location.pathname;

  const hideCrumb = useMemo(() => !shouldShowCrub(pathname), [pathname]);

  if (hideCrumb) return null;
  // @ts-ignore
  else return <BreadCrumbs />;
}
